// src/hooks/useLogout.js

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import nbrApi from '../services/nbrApi';
import { Logout } from '../store/actions/AuthActions';

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutUser = (selectedData) => {
    if (!selectedData) return;

    const payload = {
      resources_id: selectedData?.resources_id,
    };

    nbrApi
      .post('/logout', payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(Logout(navigate));
        } 
      })
      .catch((error) => {
       console.log(error)
      });
  };

  return { logoutUser };
};
